(() => {
  // Only target product cards inside collection grids
  const LINK_SELECTOR = [
    '.product-grid a.full-unstyled-link',
    '.product-grid .card__media a',
    '.product-grid .card__heading a',
    '.product-grid .card__content a'
  ].join(', ');

  function isModifiedClick(e) {
    return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0;
  }

  document.addEventListener(
    'click',
    (e) => {
      if (isModifiedClick(e)) return;

      // If they clicked a real button/input inside the card, don't hijack it
      if (e.target.closest('button, input, select, textarea, [role="button"]')) return;

      const link = e.target.closest(LINK_SELECTOR);
      if (!link) return;

      const card =
        link.closest('.card-wrapper') ||
        link.closest('.product-card-wrapper') ||
        link.closest('.grid__item');

      if (!card) return;

      // "Choose options" / quick-add modal opener (Ride/Dawn style)
      const quickAddButton =
        card.querySelector('modal-opener button') ||
        card.querySelector('button.quick-add__submit') ||
        card.querySelector('button[name="add"]');

      // If no quick add exists, let it navigate normally
      if (!quickAddButton) return;

      e.preventDefault();
      e.stopPropagation();

      quickAddButton.click();
    },
    true // capture = we intercept before the link navigates
  );
})();
